import type { ComponentPropsWithoutRef } from 'react'

const BaseSelectPanel = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => <div className={`px-5 py-2.5 ${className}`} {...props} />

export default BaseSelectPanel
